<template>
  <fragment>
    <b-modal
      id="modal-publish"
      size="lg"
      hide-header
      hide-footer
    >
        <div
          id="close-modal-publish"
          type="button"
          aria-label="Close"
          @click="closeModal()"
        >
          <i class="fal fa-times"></i>
        </div>
        <div class="title">Congratulations!</div>
        <div class="desc">Your website has been published, and live online</div>
        <div class="icon-website"> 
          <img :src="require('@assets/images/publish.png')" height="130"/>
        </div>
        <div class="domian-container">
          <div class="domian-wrap">
            <div class="icon-domain"><i class="fas fa-arrow-right"></i></div>
            <div class="icon-domain"><i class="fas fa-redo"></i></div>
            <div class="input-domain">
              <div>{{domain}}</div>
            </div>
          </div>
          <div class="btn-view-site">
            <b-button variant="primary" @click="viewSite">View Site</b-button>
          </div>
        </div>
        <div class="info">This is an address people will find your website online.</div>
    </b-modal>
  </fragment>
</template>

<script>
import { mapGetters } from "vuex";
// import IconWebsite from "@components_system/Shared/Images/Website/Website";

export default {
  components: {
    // IconWebsite
  },

  data() {
    return {
      render: true,
    };
  },

  watch: {
    modal: {
      handler() {
        if (this.modal == "modal-publish") {
          this.$bvModal.show("modal-publish");
        }
      },
    },
  },

  computed: {
    ...mapGetters({
      domains: "design/site/domains",
      modal: "design/modal",
      languageUse: "design/site/languageUse",
      languageDefault: "design/site/languageDefault",
    }),
    domain() {
      return 'https://' + this.domains.main + (this.languageUse == this.languageDefault ? '' : '/' + this.languageUse)
    },
  },

  methods: {
    closeModal() {
      this.$store.dispatch("design/setModal", { name: "" });
      this.$bvModal.hide("modal-publish");
    },
    viewSite() {
      window.open(this.domain)
      this.closeModal()
    }
  }
};
</script>

<style lang="scss">
#modal-publish {
  .modal-dialog {
    width: 600px;
  }
  .modal-body {
    padding: 15px 20px;
    #close-modal-publish {
      font-size: 25px;
      height: 16px;
      position: relative;
      svg {
        position: absolute;
        right: 0;
        top: -5px;
      }
    }
    .title {
      font-family: 'MWE_DB_Heavent';
      font-style: normal;
      font-weight: 700;
      font-size: 40px;
      line-height: 40px;
      text-align: center;
      color: #373E44;
    }
    .desc {
      margin-top: 5px;
      font-family: 'Sarabun';
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
      text-align: center;
      color: #53585D;
    }
    .icon-website {
      margin-top: 15px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .domian-container {
      display: flex;
      align-items: center;
      margin: 15px 10px 0 10px;
      .domian-wrap {
        display: flex;
        flex-grow: 1;
        align-items: center;
        padding: 8px 30px 8px 10px;
        gap: 8px;
        background: #E8ECEF;
        border-radius: 4px;
        .icon-domain {
          color: #84929F;
        }
        .input-domain {
          width: 100%;
          padding: 2px 16px 3px;
          background: #FFFFFF;
          border-radius: 20px;
          font-family: 'Sarabun';
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          line-height: 20px;
          color: #53585D;
        }
      }
      .btn-view-site {
        margin-left: 15px;
      }
    }
    .info {
      font-family: 'Sarabun';
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 16px;
      text-align: center;
      color: #84929F;
      margin-top: 15px;
      margin-bottom: 15px;
    }
  }
}
</style>
